import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { UiFormModule } from "../../../shared/ui/ui-form.module";
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { RouterModule } from "@angular/router";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";


import { MatAutocompleteModule } from "@angular/material/autocomplete";

import { InvestmentAssetIntangibleListComponent } from "./components/investment-asset-intangible-list/investment-asset-intangible-list.components";
import { InvestmentAssetIntangibleEffects } from "./store/effects/investment-asset-intangible.effects";
import { InvestmentAssetIntangibleReducer } from "./store/reducers/investment-asset-intangible.reducer";
import { InvestmentAssetIntangibleService } from "./services/investment-asset-intangible.service";
import { SharedModule } from "../../shared/shared.module";
import { InvestmentAssetSharedModule } from "../investment-asset-shared/investment-asset-shared.module";




@NgModule({
  declarations:[
    InvestmentAssetIntangibleListComponent
  ],
  exports:[
    InvestmentAssetIntangibleListComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    UiFormModule,
    RouterModule,
    FormsModule,
    SharedModule,
    InvestmentAssetSharedModule,

    // Angular Material
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatTableModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatToolbarModule,
    MatCardModule,
    MatDividerModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatSnackBarModule,

    // NgRx
    StoreModule.forFeature('investmentAssetIntangible', InvestmentAssetIntangibleReducer),
    EffectsModule.forFeature([InvestmentAssetIntangibleEffects])
  ],
  providers: [
    InvestmentAssetIntangibleService
  ]
})

export class InvestmentAssetIntangibleModule { }
